import { Component, OnInit, ElementRef, OnDestroy, EventEmitter, Output , ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ip } from 'src/app/constant/constant';
import { DataService } from 'src/app/services/data.service';
import { ToastService } from 'src/app/services/toast.service';
import { MapService } from 'src/app/services/map.service';
import { Subscription } from 'rxjs';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoordinatesService } from 'src/app/services/coordinates.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
    selector: 'app-invitation-detailpage',
    templateUrl: './invitation-detailpage.component.html',
    styleUrls: ['./invitation-detailpage.component.scss'],
    standalone: false
})
export class InvitationDetailpageComponent implements OnInit, OnDestroy {
  @Output() statusUpdated: EventEmitter<string> = new EventEmitter<string>();
  invitationdetail: any;
  imageurl = ip
  selectedCharacterid: any;
  characterNames: any = [];
  char_id: any;
  user_id: any;
  characternullerror: any;
  startlocation: any;
  invitationForm: FormGroup;
  map_id: any;
  culture: any = "";
  private pointSubscription: Subscription;
  constructor(private route: ActivatedRoute, private toastService: ToastService,
    private dataserv: DataService, private router: Router,
    private activeModal: NgbActiveModal,
    private mapService: MapService, private elementRef: ElementRef,
    private currentUserService: CurrentUserService,
    private formBuilder: FormBuilder,
    private coordinatesService: CoordinatesService, private cdr: ChangeDetectorRef) {
    this.invitationForm = this.formBuilder.group({
      charOption: [{}, Validators.required],
      culture: ['', Validators.required]

    })
    // this.pointSubscription = this.coordinatesService.pointDrawn$.subscribe((coordinates) => {

    //   this.startlocation = coordinates;
    //   const url = this.mapService.getFeatureinfo(3, coordinates,'1111')
    //   fetch(url).then((res) => { return res.text(); }).then(res => {
    //     const feature = JSON.parse(res)['features'];

    //     this.culture = feature.length > 0 ? feature[0].properties.name : "";
    //     if (this.culture?.length > 0) {
    //       this.invitationForm.get("culture").setValue(this.culture)
    //       this.invitationForm.updateValueAndValidity()
    //     }
    //     else {
    //       this.toastService.showSuccess('Culture Not Avaliable at drop location', 'danger')
    //     }
    //   })
    //   // Do something with the coordinates, e.g., update the UI
    // });


  }

  ngOnInit(): void {


    // Accessing route parameters
    this.route.params.subscribe(params => {
      const userId = params['user_id']; // Accessing user_id parameter
      const invitationId = params['invitation_id']; // Accessing invitation_id parameter
      this.getinvitation(userId, invitationId)
    
          this.cdr.detectChanges();});
    this.currentUserService.currentUser.subscribe((data) => {
      if (data) {
        this.user_id = data.id;
        this.cdr.detectChanges();
      }
    })
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    this.pointSubscription.unsubscribe();
    this.mapService.removeOldMap()
  }

  ngAfterViewInit(): void {

  }

  getinvitation(userId: any, invitationId: any) {
    this.dataserv.get_invitationdetail(userId, invitationId).subscribe((data: any) => {
      if (data) {

        this.invitationdetail = data.invitations
        this.char_id = this.invitationdetail[0].character_id
        this.map_id = this.invitationdetail[0].map_id
        this.getcharlist(this.char_id, this.map_id);
        this.cdr.detectChanges();
      }
    },
      (error) => {
        this.toastService.showSuccess(error.error.message, 'danger');
      
          this.cdr.detectChanges();})
  }

  getcharlist(char_id, map_id) {
    this.dataserv.Getcharacterdetail(this.user_id, map_id).subscribe((res: any) => {
      this.characterNames = res.character_details.filter(character => character.nickname !== null);

      this.selectedCharacterid = char_id;
      this.cdr.detectChanges();
      const invitedUser = this.characterNames.find(invitation => invitation.id === char_id);

      this.invitationForm.get('charOption').setValue(invitedUser)
      this.mapService?.addPointDrawInteraction(this.invitationForm.value.charOption !== null ? this.invitationForm.value.charOption : '/media/media/char_detail_imgs/spotonmap_25_Images.png', this.startlocation, null)

    },
      (error) => {
        this.toastService.showSuccess(error.error.error, 'danger');
        this.router.navigate(['player-detail/create'])
      
          this.cdr.detectChanges();})
  }


  onOptionChange(character): void {
    this.pointSubscription = this.coordinatesService.pointDrawn$.subscribe((coordinates) => {

      this.startlocation = coordinates;
      this.cdr.detectChanges();
      // Do something with the coordinates, e.g., update the UI
    });
    if (!this.startlocation) {
      this.mapService?.addPointDrawInteraction(this.invitationForm.value.charOption, null)
      return
    }

    this.mapService?.addPointDrawInteraction(this.invitationForm.value.charOption !== null ? this.invitationForm.value.charOption : '/media/media/char_detail_imgs/spotonmap_25_Images.png', this.startlocation, 'Changed')

  }

  save(invitationdata: any, status: string) {

    if (this.invitationForm.valid) {
      const data = {
        "id": invitationdata.id,
        "game_id": invitationdata.game_id,
        "status": status,
        "character_id": Number(this.invitationForm.value.charOption.id),
        "geography": this.startlocation?.join(),
        "culture": this.invitationForm?.value?.culture ? this.invitationForm?.value.culture : ''
      };

      this.dataserv.invitationdetailstatusupdate(data).subscribe((res) => {
        if (status === 'REJECTED') {
          this.toastService.showSuccess('Invitation declined.', 'success');
        } else {
          this.toastService.showSuccess('Invitation accepted.', 'success');
        }
        this.cdr.detectChanges();
        this.statusUpdated.emit(status);
        this.closeModal(status); // Pass status when closing
      }, (err) => {
        console.error('Error updating status:', err);
      
          this.cdr.detectChanges();});
    }
  }

  closeModal(status?: string) {
    this.activeModal.close(status); // Pass status when closing modal
  }

}
